import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Suspense } from "react";
import Navbar from "./Navbar";
import HomePage from "./HomePage";
import Timeline from "./Timeline";
import TeamsPeople from "./Teams&People";
import GetInvolved from "./GetInvolved";
import Login from "./Login";
import Signup from "./SignUp";
import AddBlog from "./AddBlog";
import BlogList from "./BlogList";
import BlogDetail from "./BlogDetail";
import DrivetrainPage from "./DrivetrainPage";
import ChassisPage from "./ChassisPage";
import WeaponsPage from "./WeaponsPage";
import SoftwarePage from "./SoftwarePage";
import SponsorsPage from "./SponsorsPage";


function App() {
  return (
    <div className="App">
      <Suspense fallback={<div className="app-loading" aria-busy="true">Loading…</div>}>
        <Router basename="/">
          <Navbar />
          <main className="App-main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/Timeline" element={<Timeline />} />
            <Route path="/TeamsPeople" element={<TeamsPeople />} />
            <Route path="/GetInvolved" element={<GetInvolved />} />
            <Route path="/Sponsors" element={<SponsorsPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/addblog" element={<AddBlog />} />
            <Route path="/blogs" element={<BlogList />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/drivetrain" element={<DrivetrainPage />} />
            <Route path="/chassis" element={<ChassisPage />} />
            <Route path="/weapons" element={<WeaponsPage />} />
            <Route path="/software" element={<SoftwarePage />} />
          </Routes>
          </main>
        </Router>
      </Suspense>
    </div>
  );
}

export default App;
